import type { Business } from "@/types/directory";

export const businessesPartA: Business[] = [
  {
    id: "biz-01",
    slug: "sree-gokul-pure-veg-restaurant",
    name: "Sree Gokul Pure Veg Restaurant",
    tagline: "Authentic Mangalorean vegetarian thali since 1994",
    description:
      "A family-run pure vegetarian restaurant in the heart of Mangaluru serving unlimited banana-leaf thali, ghee roast dosa and traditional Udupi breakfast. Known across the district for consistent taste, quick service and spotless hygiene.",
    categorySlug: "restaurants",
    subcategory: "Pure Veg Restaurants",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Gokul Complex, Car Street, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 1120",
    whatsapp: "+91 98450 33120",
    email: "hello@sreegokulveg.in",
    website: "https://sreegokulveg.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Mangaluru%20Car%20Street%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20modern%20South%20Indian%20pure%20vegetarian%20restaurant%20interior%20with%20wooden%20tables%2C%20brass%20lamps%20and%20warm%20ambient%20lighting%2C%20clean%20minimalist%20decor%2C%20appetizing%20dining%20photography&width=1200&height=800&seq=cbc-biz-gokul-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Traditional%20banana%20leaf%20vegetarian%20thali%20with%20rice%2C%20curries%20and%20sweets%20served%20on%20a%20wooden%20table%2C%20warm%20food%20photography&width=1200&height=800&seq=cbc-biz-gokul-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Crispy%20golden%20ghee%20roast%20dosa%20with%20chutney%20and%20sambar%20on%20a%20steel%20plate%2C%20close%20up%20South%20Indian%20food%20photography&width=1200&height=800&seq=cbc-biz-gokul-g2-01&orientation=landscape",
    ],
    rating: 4.7,
    reviewCount: 1284,
    verified: true,
    sponsored: true,
    featured: true,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 31,
    hours: [
      { day: "Monday", open: "07:00", close: "22:30", closed: false },
      { day: "Tuesday", open: "07:00", close: "22:30", closed: false },
      { day: "Wednesday", open: "07:00", close: "22:30", closed: false },
      { day: "Thursday", open: "07:00", close: "22:30", closed: false },
      { day: "Friday", open: "07:00", close: "22:30", closed: false },
      { day: "Saturday", open: "07:00", close: "23:00", closed: false },
      { day: "Sunday", open: "07:00", close: "23:00", closed: false },
    ],
    services: ["Unlimited Thali", "Breakfast", "Takeaway", "Bulk Catering"],
    tags: ["Pure Veg", "Family Friendly", "Car Street", "Dine In"],
    reviews: [
      {
        id: "rev-01-1",
        author: "Pradeep N.",
        rating: 5,
        date: "2026-08-12",
        comment: "The unlimited thali is unbelievable value. Clean, quick and the staff are so courteous.",
        verified: true,
      },
      {
        id: "rev-01-2",
        author: "Sneha Rao",
        rating: 5,
        date: "2026-07-28",
        comment: "Best ghee roast in Mangaluru, no doubt. We come here every weekend with family.",
        verified: true,
      },
      {
        id: "rev-01-3",
        author: "Manoj Hegde",
        rating: 4,
        date: "2026-06-30",
        comment: "Great food and very hygienic. Parking is a bit tight during lunch hours.",
        verified: false,
      },
    ],
    videoUrl: "https://www.youtube.com/watch?v=ScMzIvxBSi4",
  },
  {
    id: "biz-02",
    slug: "kadri-grand-hotel-and-suites",
    name: "Kadri Grand Hotel & Suites",
    tagline: "Business-class comfort in central Mangaluru",
    description:
      "A contemporary 62-room hotel with conference facilities, rooftop dining and airport transfers, ideal for business travellers and wedding parties visiting Mangaluru. Located minutes from Kadri Park and the city's commercial hubs.",
    categorySlug: "hotels",
    subcategory: "Business Hotels",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Kadri Hills Road, Mangaluru, Dakshina Kannada - 575002",
    phone: "+91 824 249 4400",
    whatsapp: "+91 98860 24400",
    email: "reservations@kadrigrand.com",
    website: "https://kadrigrand.com",
    mapEmbedUrl: "https://www.google.com/maps?q=Kadri%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20coastal%20luxury%20hotel%20exterior%20and%20lobby%20with%20palm-lined%20driveway%2C%20warm%20evening%20lighting%2C%20contemporary%20Indian%20architecture%2C%20welcoming%20entrance%2C%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-kadri-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Spacious%20modern%20hotel%20suite%20with%20king%20bed%2C%20warm%20neutral%20tones%20and%20soft%20lighting%2C%20luxury%20interior%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-kadri-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Rooftop%20hotel%20restaurant%20with%20set%20tables%20and%20evening%20city%20view%2C%20warm%20ambient%20lighting%2C%20hospitality%20dining%20photography&width=1200&height=800&seq=cbc-biz-kadri-g2-01&orientation=landscape",
    ],
    rating: 4.6,
    reviewCount: 642,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 12,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["Rooms & Suites", "Conference Hall", "Airport Transfer", "Rooftop Dining"],
    tags: ["4 Star", "Business Stay", "Airport Pickup", "WiFi"],
    reviews: [
      {
        id: "rev-02-1",
        author: "Rahul Menon",
        rating: 5,
        date: "2026-08-02",
        comment: "Very comfortable stay for a business trip. Conference room was well equipped and the staff were professional.",
        verified: true,
      },
      {
        id: "rev-02-2",
        author: "Anita Fernandes",
        rating: 4,
        date: "2026-07-19",
        comment: "Central location, clean rooms and a lovely rooftop dinner. Breakfast spread could be wider.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-03",
    slug: "coastal-care-multispecialty-hospital",
    name: "Coastal Care Multispecialty Hospital",
    tagline: "Trusted multispeciality care in Mangaluru",
    description:
      "A 120-bed multispeciality hospital offering cardiology, orthopaedics, paediatrics, maternity and 24-hour emergency care with modern diagnostics and experienced consultants from across Karnataka.",
    categorySlug: "healthcare",
    subcategory: "Multispeciality Hospitals",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Balmatta Road, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 9911",
    whatsapp: "+91 94480 29911",
    email: "care@coastalcarehospital.in",
    website: "https://coastalcarehospital.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Balmatta%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20multispeciality%20hospital%20building%20exterior%20with%20clean%20glass%20facade%2C%20landscaped%20entrance%20and%20bright%20daylight%2C%20professional%20healthcare%20architecture%20photography&width=1200&height=800&seq=cbc-biz-coastalcare-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Clean%20bright%20hospital%20reception%20and%20waiting%20area%20with%20comfortable%20seating%20and%20soft%20natural%20light%2C%20healthcare%20interior%20photography&width=1200&height=800&seq=cbc-biz-coastalcare-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Advanced%20medical%20diagnostic%20equipment%20room%20in%20a%20modern%20hospital%2C%20clean%20clinical%20environment%2C%20healthcare%20technology%20photography&width=1200&height=800&seq=cbc-biz-coastalcare-g2-01&orientation=landscape",
    ],
    rating: 4.5,
    reviewCount: 918,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 18,
    hours: [
      { day: "Monday", open: "00:00", close: "23:59", closed: false },
      { day: "Tuesday", open: "00:00", close: "23:59", closed: false },
      { day: "Wednesday", open: "00:00", close: "23:59", closed: false },
      { day: "Thursday", open: "00:00", close: "23:59", closed: false },
      { day: "Friday", open: "00:00", close: "23:59", closed: false },
      { day: "Saturday", open: "00:00", close: "23:59", closed: false },
      { day: "Sunday", open: "00:00", close: "23:59", closed: false },
    ],
    services: ["24x7 Emergency", "Cardiology", "Orthopaedics", "Maternity"],
    tags: ["NABL Lab", "Cashless Insurance", "Emergency", "Pharmacy"],
    reviews: [
      {
        id: "rev-03-1",
        author: "Vinaya K.",
        rating: 5,
        date: "2026-08-09",
        comment: "Emergency team was quick and caring. The doctors explained everything clearly.",
        verified: true,
      },
      {
        id: "rev-03-2",
        author: "Suresh Bhat",
        rating: 4,
        date: "2026-07-15",
        comment: "Good facilities and clean wards. Billing process was transparent.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-04",
    slug: "mangala-builders-and-developers",
    name: "Mangala Builders & Developers",
    tagline: "Building coastal homes since 2001",
    description:
      "A RERA-registered developer delivering apartments, villas and commercial spaces across Mangaluru and the wider Dakshina Kannada region, with in-house design, construction and after-sales support.",
    categorySlug: "real-estate",
    subcategory: "Builders & Developers",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Hampankatta Main Road, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 242 7700",
    whatsapp: "+91 99019 27700",
    email: "sales@mangalabuilders.in",
    website: "https://mangalabuilders.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Hampankatta%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20residential%20apartment%20project%20with%20sales%20office%20and%20architectural%20render%20boards%2C%20contemporary%20Indian%20housing%20development%2C%20bright%20daylight%2C%20real%20estate%20photography&width=1200&height=800&seq=cbc-biz-mangala-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Newly%20completed%20modern%20apartment%20tower%20with%20balconies%20and%20landscaped%20garden%2C%20clear%20blue%20sky%2C%20architectural%20photography&width=1200&height=800&seq=cbc-biz-mangala-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bright%20spacious%20model%20apartment%20living%20room%20with%20modern%20furniture%20and%20large%20windows%2C%20interior%20real%20estate%20photography&width=1200&height=800&seq=cbc-biz-mangala-g2-01&orientation=landscape",
    ],
    rating: 4.4,
    reviewCount: 187,
    verified: true,
    sponsored: false,
    featured: false,
    plan: "Business",
    openNow: false,
    yearsInBusiness: 25,
    hours: [
      { day: "Monday", open: "09:30", close: "18:30", closed: false },
      { day: "Tuesday", open: "09:30", close: "18:30", closed: false },
      { day: "Wednesday", open: "09:30", close: "18:30", closed: false },
      { day: "Thursday", open: "09:30", close: "18:30", closed: false },
      { day: "Friday", open: "09:30", close: "18:30", closed: false },
      { day: "Saturday", open: "10:00", close: "17:00", closed: false },
      { day: "Sunday", open: "00:00", close: "00:00", closed: true },
    ],
    services: ["Apartments", "Villas", "Commercial Spaces", "Site Visits"],
    tags: ["RERA Registered", "25 Years", "Villas", "Apartments"],
    reviews: [
      {
        id: "rev-04-1",
        author: "Harish Poojary",
        rating: 5,
        date: "2026-07-30",
        comment: "Handover was on time and quality was as promised. The team was responsive throughout.",
        verified: true,
      },
      {
        id: "rev-04-2",
        author: "Latha Shenoy",
        rating: 4,
        date: "2026-06-21",
        comment: "Good construction quality. Documentation took a little longer than expected.",
        verified: false,
      },
    ],
  },
  {
    id: "biz-05",
    slug: "puttur-prime-motors",
    name: "Puttur Prime Motors",
    tagline: "Multi-brand car dealership and service",
    description:
      "Authorised multi-brand car showroom and service centre serving Puttur, Sullia and the surrounding taluk. Offers new and pre-owned cars, insurance assistance and genuine spare parts.",
    categorySlug: "automobile",
    subcategory: "Car Dealers",
    districtSlug: "south-canara",
    locationSlug: "puttur",
    address: "Uppinangady Road, Puttur, Dakshina Kannada - 574201",
    phone: "+91 8251 233 900",
    whatsapp: "+91 90083 33900",
    email: "sales@putturprimemotors.in",
    website: "https://putturprimemotors.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Puttur%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20multi-brand%20car%20showroom%20interior%20with%20polished%20floors%2C%20bright%20showroom%20lighting%20and%20neatly%20arranged%20vehicles%2C%20professional%20automotive%20retail%20photography&width=1200&height=800&seq=cbc-biz-puttur-motors-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Clean%20modern%20car%20service%20bay%20with%20a%20vehicle%20on%20a%20lift%20and%20organized%20tools%2C%20bright%20workshop%20lighting%2C%20automotive%20service%20photography&width=1200&height=800&seq=cbc-biz-puttur-motors-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Neat%20row%20of%20polished%20cars%20in%20a%20dealership%20lot%20with%20sales%20flags%2C%20bright%20daylight%2C%20automotive%20dealership%20photography&width=1200&height=800&seq=cbc-biz-puttur-motors-g2-01&orientation=landscape",
    ],
    rating: 4.3,
    reviewCount: 156,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 9,
    hours: [
      { day: "Monday", open: "09:00", close: "19:00", closed: false },
      { day: "Tuesday", open: "09:00", close: "19:00", closed: false },
      { day: "Wednesday", open: "09:00", close: "19:00", closed: false },
      { day: "Thursday", open: "09:00", close: "19:00", closed: false },
      { day: "Friday", open: "09:00", close: "19:00", closed: false },
      { day: "Saturday", open: "09:00", close: "19:00", closed: false },
      { day: "Sunday", open: "10:00", close: "14:00", closed: false },
    ],
    services: ["New Cars", "Pre-Owned Cars", "Service & Repair", "Insurance"],
    tags: ["Multi-Brand", "Test Drive", "Spare Parts", "Finance"],
    reviews: [
      {
        id: "rev-05-1",
        author: "Ravi Shankar",
        rating: 5,
        date: "2026-08-05",
        comment: "Bought a pre-owned car here. Transparent pricing and they handled the insurance smoothly.",
        verified: true,
      },
      {
        id: "rev-05-2",
        author: "Nagesh M.",
        rating: 4,
        date: "2026-07-11",
        comment: "Service quality is good. Waiting area could be better.",
        verified: false,
      },
    ],
  },
  {
    id: "biz-06",
    slug: "surathkal-fashion-hub",
    name: "Surathkal Fashion Hub",
    tagline: "Trendy clothing for the whole family",
    description:
      "A bright multi-floor fashion store near Surathkal beach stocking menswear, womenswear, kids' clothing and ethnic wear, with seasonal collections and alteration service in-store.",
    categorySlug: "retail",
    subcategory: "Fashion & Apparel",
    districtSlug: "south-canara",
    locationSlug: "surathkal",
    address: "Main Road, Surathkal, Dakshina Kannada - 575014",
    phone: "+91 824 247 6644",
    whatsapp: "+91 94808 76644",
    email: "care@surathkalfashion.in",
    website: "https://surathkalfashion.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Surathkal%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20contemporary%20clothing%20boutique%20interior%20with%20neatly%20displayed%20apparel%20racks%2C%20warm%20accent%20lighting%20and%20welcoming%20retail%20atmosphere%2C%20editorial%20fashion%20store%20photography&width=1200&height=800&seq=cbc-biz-surathkal-fashion-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Colourful%20folded%20stack%20of%20fashionable%20clothes%20on%20a%20clean%20retail%20display%20table%2C%20soft%20lighting%2C%20retail%20merchandising%20photography&width=1200&height=800&seq=cbc-biz-surathkal-fashion-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Elegant%20ethnic%20Indian%20wear%20displayed%20on%20mannequins%20in%20a%20bright%20store%2C%20warm%20lighting%2C%20apparel%20retail%20photography&width=1200&height=800&seq=cbc-biz-surathkal-fashion-g2-01&orientation=landscape",
    ],
    rating: 4.2,
    reviewCount: 214,
    verified: false,
    sponsored: false,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 7,
    hours: [
      { day: "Monday", open: "09:30", close: "21:00", closed: false },
      { day: "Tuesday", open: "09:30", close: "21:00", closed: false },
      { day: "Wednesday", open: "09:30", close: "21:00", closed: false },
      { day: "Thursday", open: "09:30", close: "21:00", closed: false },
      { day: "Friday", open: "09:30", close: "21:30", closed: false },
      { day: "Saturday", open: "09:30", close: "22:00", closed: false },
      { day: "Sunday", open: "10:00", close: "21:00", closed: false },
    ],
    services: ["Menswear", "Womenswear", "Kids Wear", "Alterations"],
    tags: ["Family Store", "Ethnic Wear", "Seasonal Sale", "Cards Accepted"],
    reviews: [
      {
        id: "rev-06-1",
        author: "Ramya S.",
        rating: 4,
        date: "2026-07-26",
        comment: "Good collection and reasonable prices. Staff helped pick the right size quickly.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-07",
    slug: "moodabidri-green-grocers",
    name: "Moodabidri Green Grocers",
    tagline: "Fresh vegetables and daily needs, every day",
    description:
      "A neighbourhood supermarket and fresh vegetable store in Moodabidri offering farm-fresh produce, provisions, household essentials and home delivery across the town.",
    categorySlug: "supermarkets",
    subcategory: "Supermarkets",
    districtSlug: "south-canara",
    locationSlug: "moodabidri",
    address: "Church Road, Moodabidri, Dakshina Kannada - 574227",
    phone: "+91 8258 236 220",
    whatsapp: "+91 97319 36220",
    email: "orders@moodabidrigrocers.in",
    website: "",
    mapEmbedUrl: "https://www.google.com/maps?q=Moodabidri%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20neighbourhood%20grocery%20supermarket%20aisle%20with%20neatly%20stacked%20produce%2C%20warm%20lighting%20and%20clean%20organized%20shelves%2C%20appealing%20retail%20photography&width=1200&height=800&seq=cbc-biz-moodabidri-grocers-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Colorful%20fresh%20vegetables%20and%20fruits%20arranged%20neatly%20in%20crates%20at%20a%20market%20stall%2C%20bright%20natural%20light%2C%20food%20retail%20photography&width=1200&height=800&seq=cbc-biz-moodabidri-grocers-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Tidy%20supermarket%20shelves%20stocked%20with%20packaged%20provisions%20and%20household%20essentials%2C%20bright%20clean%20lighting%2C%20retail%20photography&width=1200&height=800&seq=cbc-biz-moodabidri-grocers-g2-01&orientation=landscape",
    ],
    rating: 4.5,
    reviewCount: 132,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Free",
    openNow: true,
    yearsInBusiness: 6,
    hours: [
      { day: "Monday", open: "07:00", close: "21:00", closed: false },
      { day: "Tuesday", open: "07:00", close: "21:00", closed: false },
      { day: "Wednesday", open: "07:00", close: "21:00", closed: false },
      { day: "Thursday", open: "07:00", close: "21:00", closed: false },
      { day: "Friday", open: "07:00", close: "21:00", closed: false },
      { day: "Saturday", open: "07:00", close: "21:30", closed: false },
      { day: "Sunday", open: "07:00", close: "20:00", closed: false },
    ],
    services: ["Fresh Vegetables", "Provisions", "Home Delivery", "Bulk Orders"],
    tags: ["Farm Fresh", "Home Delivery", "Daily Needs", "UPI Accepted"],
    reviews: [
      {
        id: "rev-07-1",
        author: "Shobha R.",
        rating: 5,
        date: "2026-08-14",
        comment: "Vegetables are always fresh and the home delivery is reliable. Very convenient.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-08",
    slug: "udupi-sagar-grand",
    name: "Udupi Sagar Grand",
    tagline: "Traditional Udupi dining done right",
    description:
      "A celebrated vegetarian restaurant near Udupi's temple town serving traditional banana-leaf meals, Udupi-style breakfast and evening snacks, with a dedicated family dining hall and banquet facility.",
    categorySlug: "restaurants",
    subcategory: "Pure Veg Restaurants",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Car Street, Udupi, Udupi District - 576101",
    phone: "+91 820 252 3300",
    whatsapp: "+91 98865 23300",
    email: "info@udupisagargrand.in",
    website: "https://udupisagargrand.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Udupi%20Car%20Street%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Udupi%20style%20vegetarian%20restaurant%20with%20banana%20leaf%20thali%20service%2C%20wooden%20seating%20and%20warm%20inviting%20lighting%2C%20authentic%20South%20Indian%20dining%20photography&width=1200&height=800&seq=cbc-biz-udupi-sagar-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Traditional%20South%20Indian%20breakfast%20spread%20with%20idli%2C%20dosa%2C%20vada%20and%20chutneys%20on%20banana%20leaf%2C%20warm%20food%20photography&width=1200&height=800&seq=cbc-biz-udupi-sagar-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Clean%20spacious%20family%20dining%20hall%20in%20a%20South%20Indian%20vegetarian%20restaurant%2C%20warm%20lighting%2C%20hospitality%20interior%20photography&width=1200&height=800&seq=cbc-biz-udupi-sagar-g2-01&orientation=landscape",
    ],
    rating: 4.6,
    reviewCount: 986,
    verified: true,
    sponsored: true,
    featured: true,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 42,
    hours: [
      { day: "Monday", open: "06:30", close: "22:00", closed: false },
      { day: "Tuesday", open: "06:30", close: "22:00", closed: false },
      { day: "Wednesday", open: "06:30", close: "22:00", closed: false },
      { day: "Thursday", open: "06:30", close: "22:00", closed: false },
      { day: "Friday", open: "06:30", close: "22:00", closed: false },
      { day: "Saturday", open: "06:30", close: "22:30", closed: false },
      { day: "Sunday", open: "06:30", close: "22:30", closed: false },
    ],
    services: ["Banana Leaf Meals", "Breakfast", "Banquet Hall", "Takeaway"],
    tags: ["Heritage", "Pure Veg", "Family Dining", "Banquet"],
    reviews: [
      {
        id: "rev-08-1",
        author: "Krishna Prasad",
        rating: 5,
        date: "2026-08-11",
        comment: "The authentic Udupi taste we grew up with. Clean, spacious and friendly service.",
        verified: true,
      },
      {
        id: "rev-08-2",
        author: "Divya K.",
        rating: 4,
        date: "2026-07-22",
        comment: "Loved the breakfast. Gets crowded on weekends so go early.",
        verified: true,
      },
    ],
  },
];